<template>
  <div>
    <layout-one>
      <el-form label-width="100px" :inline="true" :rules="rules" ref="ruleForm" :model="requestForm">
        <div class="section large-ele-input__">
          <h4>层次</h4>
          <div class="sectionBox">
            <el-form-item label="层次" prop="levelId">
              <el-select v-model="requestForm.levelId" placeholder="请选择" >
              <el-option
                v-for="item in levelList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <!-- 专业多选 -->
        <div class="section mt20">
          <h4>专业</h4>
          <div class="sectionBox">
            <el-form-item label="请选择">
              <div class="stationBox">
                <div class="stationTop">
                  <el-checkbox :indeterminate="subjectMinate" v-model="checkAllSubject" @change="checkAllSubjectFn">全选
                  </el-checkbox>
                  <div class="searchCourse ml30">
                    <el-input placeholder="快捷搜索" v-model="subjectStr"></el-input>
                    <div class="searchPos">
                      <i class="iconfont icon-sousuo"></i>
                    </div>
                  </div>
                </div>
                <div class="station-container">
                  <el-checkbox-group v-model="requestForm.subjectIdList" @change="subjectChange">
                    <el-checkbox v-for="subject in subjectSelectData" :label="subject.id" :key="subject.id"
                      :title="subject.name">{{ subject.name }}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <!-- 课程多选 -->
        <div class="section mt20">
          <h4>课程</h4>
          <div class="sectionBox">
            <el-form-item label="请选择">
              <div class="stationBox">
                <div class="stationTop">
                  <el-checkbox :indeterminate="courseMinate" v-model="checkAllCourse" @change="checkAllCourseFn">全选
                  </el-checkbox>
                  <div class="searchCourse ml30">
                    <el-input placeholder="快捷搜索" v-model="courseStr"></el-input>
                    <div class="searchPos">
                      <i class="iconfont icon-sousuo"></i>
                    </div>
                  </div>
                </div>
                <div class="station-container">
                  <el-checkbox-group v-model="requestForm.courseIdList" @change="courseChange">
                    <el-checkbox v-for="course in courseSelectData" :label="course.id" :key="course.id"
                      :title="course.name">{{ course.name }}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>

    </layout-one>
  </div>
</template>

<script>
// 引入 vuex 辅助函数, 可以使用 vuex 方法
import { mapMutations } from 'vuex'
// 接口
import { getSelectCourse } from '@/http/modules/baseSet/course'
import { getLevelList, addLevelSubjectCourseSet } from '@/http/modules/baseSet/majorCourse'

export default {
  name: 'addMajorCourse',
  data() {
    return {
      /* *** 确定 *** */
      saveMethods: 'addLSCFn',
      /* *** 取消 *** */
      backMethods: 'cancelPage',
      
      /* *** 专业全选样式的不确定状态 *** */
      subjectMinate: true,
      /* *** 课程全选样式的不确定状态 *** */
      courseMinate: true,

      /* *** 专业是否全选 *** */
      checkAllSubject: false,
      /* *** 课程是否全选 *** */
      checkAllCourse: false,

      /* *** 专业快捷搜索绑定值 *** */
      subjectStr: '',
      /* *** 专业快捷搜索绑定值 *** */
      courseStr: '',

      /* *** 所有的层次 *** */
      levelList: [],
      /* *** 所有的专业 *** */
      subjectList: [],
      /* *** 所有的课程 *** */
      courseList: [],

      /* *** 添加联动数据参数 *** */
      requestForm: {
        levelId: '',
        subjectIdList: [],
        courseIdList: [],
      },

      /* *** 表单校验规则 *** */
      rules: {
        levelId: [
          {required: true, message: '请选择层次', trigger: 'blur'}
        ],
      } 
    }
  },
  created() {
    this.initData();
  },
  mounted(){
    this.SAVE_PAGE_THIS(this);
  },
  computed: {
    /*******************************
     * @subjectSelectData
     *  - 专业搜索
     *  - 过滤输入的搜索字段并返回
     *******************************/
    subjectSelectData() {
      if (this.subjectStr) {
        return this.subjectList.filter(item => item.name.indexOf(this.subjectStr) > -1);
      }
      return this.subjectList;
    },

    /*******************************
     * @courseSelectData 课程搜索
     *******************************/
    courseSelectData(){
      if (this.courseStr) {
        return this.courseList.filter(item => item.name.indexOf(this.courseStr) > -1);
      }
      return this.courseList;
    },
  },
  methods: {
    ...mapMutations(['SAVE_PAGE_THIS']),

    /****************************
     * @initData 初始化表单数据
     ****************************/
    initData() {
      /* ** 层次 ** */
      getLevelList().then(res => {
        this.levelList = res.data;
      })
      /* ** 专业(所有) ** */
      this.mixin_getSelectSubject().then(data => {
        this.subjectList = data;
      })
      /* *** 课程(所有) *** */
      getSelectCourse().then(res => {
        this.courseList = res.data;
      })
    },

    /*******************************
     * @checkAllSubjectFn 专业全选
     *******************************/
    checkAllSubjectFn(val) {
      // 1. 获取所有专业 id
      let allSubject = this.subjectSelectData.map(item => item.id);
      // 2. 选择全选 - 配置参数
      this.requestForm.subjectIdList = val ? allSubject : [];
      // 3. 重置全选按钮选中样式
      this.subjectMinate = false;
    },

    /*******************************
     * @subjectChange 专业勾选变化
     *******************************/
    subjectChange(value) {
      // 1. 获取选中专业数量
      let checkedCount = value.length;
      // 2. 判断是否全部选中
      this.checkAllSubject = checkedCount === this.subjectSelectData.length;
      // 3. 修改全选按钮样式
      this.subjectMinate = checkedCount > 0 && checkedCount < this.subjectSelectData.length;
    },

    /*******************************
     * @checkAllCourseFn 课程全选
     *******************************/
    checkAllCourseFn(val){
      // 1. 获取所有专业 id
      let allCourse = this.courseSelectData.map(item => item.id);
      // 2. 选择全选 - 配置参数
      this.requestForm.courseIdList = val ? allCourse : [];
      // 3. 重置全选按钮选中样式
      this.courseMinate = false;
    },

    /*******************************
     * @courseChange 课程勾选变化
     *******************************/
    courseChange(value) {
      // 1. 获取选中专业数量
      let checkedCount = value.length;
      // 2. 判断是否全部选中
      this.checkAllCourse = checkedCount === this.courseSelectData.length;
      // 3. 修改全选按钮样式
      this.courseMinate = checkedCount > 0 && checkedCount < this.courseSelectData.length;
    },

    /*******************************
     * @this 添加
     *******************************/
    addLSCFn(){
      // 1. 表单验证 (levelId)
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 2. 专业是否选择 
          if (this.requestForm.subjectIdList.length == 0) {
            this.$message.warning('请选择专业！');
            return false;
          };
          // 3. 课程是否选择
          if (this.requestForm.courseIdList.length == 0) {
            this.$message.warning('请选择课程！');
            return false;
          } 
          // 4. 参数配置
          let params = { ...this.requestForm };
          params.subjectIdList = params.subjectIdList.join(',');
          params.courseIdList = params.courseIdList.join(',');
          // 5. 添加接口调用
          addLevelSubjectCourseSet(params).then( res =>{
            if ( res.code == 1) {
              // 6. 成功后, 重置表单数据格式
              this.requestForm = {
                levelId: '',
                subjectIdList: [],
                courseIdList: [],
              }
              // 7. 轻提示(成功)
              this.$message.success('添加成功！');
            }
          })
        } else {
          return false;
        }
      });
    },

    /*******************************
     * @this 返回
     *******************************/
    cancelPage(){
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="less" scoped>
.section {
  border-bottom: 1px solid #F1F2F5;
  h4 {
    margin-bottom: 30px;
  }
  .sectionBox {
    .lang {
      width: 512px;
    }
  }
  .stationBox {
    width: 1000px;
    max-height: 300px;
    background-color: #F8F9FC;
    overflow-y: auto;
    padding: 20px;
    border-radius: 8px;
    .stationTop {
      display: flex;
      margin-bottom: 20px;
    }
    .searchCourse {
      position: relative;
      .searchPos {
        width: 40px;
        height: 18px;
        line-height: 18px;
        border-left: 1px solid #E1E6ED;
        position: absolute;
        right: 0;
        top: 11px;
        color: #C2C6CC;
        font-size: 14px;

        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  /deep/ .el-form-item {
    margin-bottom: 30px !important;
  }
  /deep/ .el-radio-button__inner {
    margin-right: 16px;
    color: #45494D !important;
    background: #F4F5F8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #DADDE6 !important;
    width: 64px;
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background: #EBF5FF !important;
    border: 1px solid #006AFF !important;
    color: #006AFF !important;
    box-shadow: none;
  }
  .station-container /deep/ .el-checkbox {
    width: 300px;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
